import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, CircularProgress } from '@material-ui/core'
import logo from '../img/BEFE_4.jpg'

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: '#000000',
        height: '100vh'
    },
    logo: {
        width: 100,
        height: 'auto'
    },
    circularProgress: {
        color: '#FFFF'
    }
}))

export const SplashPage = () => {
    const classes = useStyles()

    return (
        <Fragment>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                className={classes.root}
            >
                <Grid item >
                    <img src={logo} className={classes.logo} alt="BEFE BURGERS" />
                </Grid>
                <Grid item>
                    <CircularProgress
                        className={classes.circularProgress}
                        size={40}
                        thickness={4}
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default SplashPage